import { BrowserRouter } from 'react-router'
import { AppRouter } from './routes/router.js'

export function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  )
}
